import { FieldTypes } from '../constants'
import { BooleanField, DropdownField, EmailField, FieldMap, PhoneField, TextField } from '../types'

export const hasPartnerField: BooleanField = {
  type: FieldTypes.BOOLEAN,
  placeholder: 'Patient has Partner',
  labels: [{ text: 'Do you have a partner?' }],
}

export const partnerNameField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: "Partner's Name",
}
export const partnerEmailField: EmailField = {
  optional: true,
  type: FieldTypes.EMAIL,
  placeholder: "Partner's Email",
}
export const partnerPhoneField: PhoneField = {
  type: FieldTypes.PHONE,
  placeholder: "Partner's Phone",
  optional: true,
}

export const okToContactField: BooleanField = {
  type: FieldTypes.BOOLEAN,
  placeholder: 'OK to Contact Partner',
  labels: [{ text: 'Is it OK to contact your partner?' }],
}

export const partnerContactMethodField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'How should we contact your partner?',
  options: [
    { text: 'Email', id: 'email' },
    { text: 'Text', id: 'text' },
  ],
  condition: v => !!v?.okToContact,
}
export const partnerContactField: FieldMap = {
  condition: v => v?.hasPartner,
  name: 'Partner Contact',
  children: {
    name: partnerNameField,
    phone: partnerPhoneField,
    email: partnerEmailField,
    okToContact: okToContactField,
    contactMethod: partnerContactMethodField,
  },
}
